export default import.meta.ROLLDOWN_FILE_URL_TbdG7jCMkTTKmCrZCLsSog